import axios from 'axios'

export async function getWish ({ ...values }) {
  const response = await axios.get(baseDir + 'modules/blockwishlist/managewishlist.php?action=getAll', { // eslint-disable-line
  })

  return response.data
}



// WEBPACK FOOTER //
// ./src/api/wishList/getWish.js